import { AdLarge, AdLargeProps } from '../../components/ad/ad-large'
import { LargeGroupAdBlock } from './large-group-ad.block'

export const LargeGroupAdComponent = (block: LargeGroupAdBlock) => {
  const componentProps: AdLargeProps = {
    id: block.id,
    title: block.title,
    description: block.description,
    ctaLabel: block.linkText,
    href: block.link,
    image: block.image,
  }

  return <AdLarge {...componentProps} />
}
